export class DateTime {
  private constructor(protected _date: Date | null) {}

  static create(date: Date | string | null | undefined) {
    if (!date) {
      return DateTime.createEmtpy();
    }

    if (date instanceof Date) {
      return DateTime.createFromDate(date);
    }
    return DateTime.createFromString(date);
  }

  static createFromString(date: string): DateTime {
    return new DateTime(new Date(date));
  }

  static createFromDate(date: Date): DateTime {
    return new DateTime(date);
  }

  static createEmtpy(): DateTime {
    return new DateTime(null);
  }

  isEmpty(): boolean {
    return !this._date;
  }
}
